var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { initReactI18next } from "react-i18next";
import i18next from "i18next";
import { CurrencyEnum, CURRENCY_MAP } from "../../config/currency.js";
const _I18nService = class _I18nService {
  constructor(params) {
    __publicField(this, "_i18n");
    var _a, _b;
    if (!(params == null ? void 0 : params.resources)) {
      console.warn("[i18nService]: Для корректной работы сервиса интернационализации необходимо добавить resources");
    }
    this._i18n = i18next.use(initReactI18next).createInstance(
      {
        lng: params == null ? void 0 : params.language,
        resources: (params == null ? void 0 : params.resources) || {},
        detection: {
          order: ["cookie"],
          caches: ["cookie"]
        },
        ...params
      },
      (err) => {
        if (err) {
          throw new Error(`[I18N]: ${err}`);
        }
      }
    );
    if (params == null ? void 0 : params.currency) {
      (_a = this._i18n.services.formatter) == null ? void 0 : _a.add(
        "currency",
        (value, lng, { style = "currency", currency = params.currency, currencyDisplay }) => {
          if (currency && currency === CurrencyEnum.UZS) {
            const formattedValue = new Intl.NumberFormat(lng, {
              maximumFractionDigits: 0
            }).format(value).replace(/,/g, " ");
            return `${formattedValue}${style === "currency" ? ` ${CURRENCY_MAP[CurrencyEnum.UZS]}` : ""}`;
          }
          return new Intl.NumberFormat(lng, {
            style,
            currency,
            maximumFractionDigits: 0,
            currencyDisplay
          }).format(value);
        }
      );
      (_b = this._i18n.services.formatter) == null ? void 0 : _b.add(
        "withCurrency",
        (value, lng, { style = "currency", separator = ", ", currency = params.currency, currencyDisplay }) => {
          const symbol = 0 .toLocaleString(lng, {
            style,
            currency,
            currencyDisplay,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).replace(/\d/g, "").trim();
          if (currency === CurrencyEnum.UZS) {
            return [value, symbol.replace(currency, CURRENCY_MAP[currency])].join(separator);
          }
          return [value, symbol].join(separator);
        }
      );
    }
  }
  get i18n() {
    return this._i18n;
  }
  /**
   * Метод для получения экземпляра `I18nService`.
   *
   * @param params - Параметры инициализации.
   * @returns Экземпляр `I18nService`.
   */
  static getInstance(params) {
    if (!_I18nService.instance) {
      _I18nService.instance = new _I18nService(params);
    }
    return _I18nService.instance;
  }
  /**
   * Добавляет переводы для указанного языка и пространства имен.
   *
   * @param lng - Язык, например, 'ru' | 'en' | 'uz'.
   * @param ns - Пространство имен, например, 'translation' | 'customNamespace'.
   * @param resources - Файл или объект с переводами.
   */
  addTranslations(lng, ns, resources) {
    this._i18n.addResourceBundle(lng, ns, resources, true, true);
  }
};
__publicField(_I18nService, "instance");
let I18nService = _I18nService;
export {
  I18nService
};
